import { ActionTypes } from "../constants";

const reduceRecipients = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_MSF_RECIPIENTS_SUCCESS:
            return action.data || [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceRecipients;
